module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4fbcf2c035110247216ce61d5f7429fc.png";